module.exports = __webpack_public_path__ + "static/media/img_membership_bg_01.91ad3e80.png";